import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { storageUsageSelector } from '../selectors/dashboardSelector';
import { getStorageUsageRequest } from '../actions/dashboardActions';
import StorageUsage from '../components/StorageUsage/StorageUsage';

const mapStateToProps = createStructuredSelector({ storageUsage: storageUsageSelector });
const mapDispatchToProps = { getStorageUsageRequest };

export default connect(mapStateToProps, mapDispatchToProps)(StorageUsage);
